<!--<form [formGroup]="annualPlanForm">-->
<form class="annual-plan-form" [formGroup]="annualPlanForm">
    <div mat-dialog-title
         class="title">
        <div class="subtitle">{{ formData.formTitle | translate }}</div>
    </div>
    <mat-dialog-content>
            <div class="line flex flex-col">
                <label class="language-label">{{ 'Available_languages' | translate }}:</label>
                
                <div class="language-checkbox-group">
                    <mat-checkbox
                        *ngFor="let lang of availableLangs"
                        [checked]="isLangSelected(lang.id)"
                        (change)="toggleLanguage(lang.id, $event.checked)">
                        {{ lang.shortName }}
                    </mat-checkbox>
                </div>

                <mat-error *ngIf="languagesFormControl.invalid">
                    {{ 'select_at_least_one_language' | translate }}
                </mat-error>    
            </div>
            <fieldset [disabled]="isSubmitting">
                <div class="line line-margin">
                    <mat-form-field>
                        <mat-label class="required">{{ 'Title' | translate }}</mat-label>
                        <input matInput
                               [required]="true"
                               formControlName="title"
                               class="required"
                               [value]="formData.annualPlanRow?.title"
                        >
                        <mat-error *ngIf="f['title'].errors && f['title'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <!--
                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'weeks_length_16_to_52' | translate">
                        <mat-label class="required">{{ 'WeeksLength' | translate }}</mat-label>
                        <input type="number" matInput formControlName="weeksLength" autocomplete="off">
                        <mat-error *ngIf="f.weeksLength.errors && f.weeksLength.errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                        <mat-error *ngIf="f.weeksLength.errors && f.weeksLength.errors.min">{{ 'Field_min_16' | translate }}</mat-error>
                        <mat-error *ngIf="f.weeksLength.errors && f.weeksLength.errors.max">{{ 'Field_max_52' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                -->

                <!--
                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'StartedAt' | translate }}</mat-label>
                        <input matInput formControlName="startedAt" [matDatepicker]="pickerStartedAt" (ngModelChange)="updateMinMaxPickerDate()" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="pickerStartedAt"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStartedAt startView="year" [startAt]="startDate"></mat-datepicker>
                        <mat-error *ngIf="f.startedAt.errors && f.startedAt.errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'EndedAt' | translate }}</mat-label>
                        <input matInput formControlName="endedAt" [min]="minDate" [max]="maxDate" [matDatepicker]="pickerEndedAt" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="pickerEndedAt"></mat-datepicker-toggle>
                        <mat-datepicker #pickerEndedAt startView="year"></mat-datepicker>
                        <mat-error *ngIf="f.endedAt.errors && f.endedAt.errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                -->

                <div class="line line-margin">
                    <duration-control [(value)]="duration"
                                      [label]="'WeeklyWorkingTime' | translate"
                                      [displayMode]="'hm'"
                                      [min]="60"
                    >
                    </duration-control>
                </div>

                <div class="line line-margin">

                    <!--
                    <mat-form-field>
                        <mat-label class="required">{{ 'WeeklyWorkingTime' | translate }}</mat-label>
                        <input matInput formControlName="weeklyWorkingTime" type="number">
                        <span matSuffix>{{ 'Minutes_s' | translate }}</span>
                        <mat-error *ngIf="f.weeklyWorkingTime.errors && f.weeklyWorkingTime.errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                    -->
                </div>
                <div class="line line-margin">
                    <mat-form-field>
                        <mat-label>{{ 'Comment' | translate }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="comment"
                                  [value]="formData.annualPlanRow?.comment"></textarea>
                        <mat-error *ngIf="f['comment'].errors">{{ 'Field_Max_length' | translate }}</mat-error>
                    </mat-form-field>
                </div>

</fieldset>

    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close tabindex="-1">
            {{ 'Cancel' | translate}}
        </button>

        <button mat-raised-button (click)="submitForm()" color="accent">
            {{ formData.formSaveActionTitle | translate}}
        </button>
    </mat-dialog-actions>
</form>
